export const common = {
  // Navbar
  'nav.overview': 'Overview',
  'nav.directory': 'Church Directory',
  'nav.worship': 'Worship Operations',
  'nav.live': 'Live Sabbath',
  'nav.ministries': 'Ministries',
  'nav.events': 'Events',
  'nav.adminLogin': 'Admin Login',
  'nav.language': 'Language',
  
  // Language names
  'lang.english': 'English',
  'lang.yoruba': 'Yoruba',
  'lang.hausa': 'Hausa',
  'lang.igbo': 'Igbo',
  'lang.pidgin': 'Pidgin',
  
  // Hero Section
  'hero.badge': 'National Digital Worship Infrastructure',
  'hero.title': 'We Dey Give Every Seventh-day Adventist Church for Nigeria Power',
  'hero.description': 'One digital platform wey dey connect all SDA churches for Nigeria. Get access to live worship services, find churches near you, manage events, and make our community strong through technology.',
  'hero.exploreChurches': 'Check Churches',
  'hero.worshipTools': 'Worship Tools',
  'hero.liveNow': 'Live Now',
  'hero.scrollExplore': 'Scroll make you explore',
  
  // Stats
  'stats.churches': 'Churches',
  'stats.members': 'Active Members',
  'stats.liveServices': 'Live Services Every Week',
  'stats.events': 'Events Every Month',
  
  // Features
  'features.watchLive': 'Watch Live',
  'features.watchLiveDesc': 'Join live worship services from churches all over Nigeria',
  'features.findChurch': 'Find Church',
  'features.findChurchDesc': 'Find SDA churches for your area with full information',
  'features.events': 'Events',
  'features.eventsDesc': 'Stay updated with conferences, programs, and activities',
  'features.ministriesTitle': 'Ministries',
  'features.ministriesDesc': 'Connect with different ministry departments and programs',
  
  // CTA
  'cta.title': 'You Don Ready to Connect Your Church?',
  'cta.description': 'Join the national network and bring your congregation into the digital age. Get powerful tools for worship, communication, and community building.',
  'cta.getStarted': 'Start Today',
  'cta.learnMore': 'Learn More',
  
  // Footer
  'footer.tagline': 'We dey connect Seventh-day Adventist churches all over Nigeria through new digital solutions.',
  'footer.quickLinks': 'Quick Links',
  'footer.resources': 'Resources',
  'footer.contact': 'Contact',
  'footer.home': 'Home',
  'footer.about': 'About Us',
  'footer.churches': 'Churches',
  'footer.liveStream': 'Live Stream',
  'footer.worshipGuide': 'Worship Guide',
  'footer.techSupport': 'Tech Support',
  'footer.training': 'Training',
  'footer.documentation': 'Documentation',
  'footer.email': 'Email',
  'footer.phone': 'Phone',
  'footer.address': 'Address',
  'footer.rights': 'All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  
  // Directory Page
  'directory.title': 'Church Directory',
  'directory.subtitle': 'Find Seventh-day Adventist churches all over Nigeria',
  'directory.search': 'Search churches...',
  'directory.allRegions': 'All Regions',
  'directory.allStates': 'All States',
  'directory.viewDetails': 'View Details',
  'directory.getDirections': 'Get Directions',
  'directory.members': 'members',
  
  // Live Page
  'live.title': 'Live Worship Services',
  'live.subtitle': 'Join live Sabbath services from churches all over Nigeria',
  'live.allRegions': 'All Regions',
  'live.watchNow': 'Watch Now',
  'live.viewers': 'viewers',
  'live.starting': 'Starting',
  
  // Events Page
  'events.title': 'Events Wey Dey Come',
  'events.subtitle': 'Discover conferences, workshops, and programs all over Nigeria',
  'events.allCategories': 'All Categories',
  'events.register': 'Register Now',
  'events.learnMore': 'Learn More',
  'events.attendees': 'attendees',
  
  // Ministries Page
  'ministries.title': 'Ministry Departments',
  'ministries.subtitle': 'Check our different ministry programs and departments',
  'ministries.learnMore': 'Learn More',
  'ministries.programs': 'programs',
  
  // Tools Page
  'tools.title': 'Worship Tools',
  'tools.subtitle': 'Digital solutions for modern church management',
  'tools.getStarted': 'Get Started',
  'tools.learnMore': 'Learn More',
};

export default {
  // ... existing code ...
  
  // New translations for enhanced landing page
  whatYouCanDo: 'Wetin You Fit Do',
  platformDescription: 'Find out all di ways wey our platform dey help you stay connected with your church community and grow for faith',
  learnMore: 'Learn More',
  
  howItWorks: 'How E Dey Work',
  howItWorksDesc: 'To start dey very simple. Follow these four easy steps make you begin your journey',
  
  discoverChurches: 'Discover Churches',
  discoverChurchesDesc: 'Check our complete directory of Seventh-day Adventist churches for all Nigeria. Find locations, service times, and contact information',
  
  joinWorship: 'Join Live Worship',
  joinWorshipDesc: 'Watch live-streamed services from churches all over di country. Experience worship from anywhere, anytime',
  
  participateEvents: 'Join Events',
  participateEventsDesc: 'Stay informed about conferences, workshops, and community programs. Register and participate for upcoming events',
  
  connectCommunity: 'Connect With Community',
  connectCommunityDesc: 'Engage with ministries, join small groups, and build meaningful relationships with fellow believers',
  
  whyChooseUs: 'Why You Go Choose Our Platform',
  whyChooseUsDesc: 'We build am specially for di Seventh-day Adventist community for Nigeria with features wey matter pass',
  
  accessAnywhere: 'Access Anywhere',
  accessAnywhereDesc: 'Connect with your church community from any device, whether you dey house or you dey move',
  
  secureReliable: 'Secure & Reliable',
  secureReliableDesc: 'Your data dey protected with enterprise-grade security. Enjoy uninterrupted service wey you fit trust',
  
  mobileOptimized: 'Mobile Optimized',
  mobileOptimizedDesc: 'Fully responsive design make sure say you go get seamless experience for smartphones, tablets, and desktops',
  
  communityFocused: 'Community Focused',
  communityFocusedDesc: 'We build am with input from church leaders and members to serve di unique needs of our community',
  
  stayUpdated: 'Stay Updated',
  stayUpdatedDesc: 'Receive notifications about important events, new sermons, and community announcements',
  
  comprehensiveTools: 'Complete Tools',
  comprehensiveToolsDesc: 'Access complete suite of digital tools wey we design to enhance church management and member engagement'
};
